import { jsonp } from "vue";

const state = {
  token: "",
  refresh_token: "",
  userInfo: null,
  uuid: "",
  VehicleType: [], //车辆类别
  StationCode: ""
};
const getters = {
  // 实时监听state值的变化(最新状态)
  Retoken(state) {
    // 方法名随意,主要是来承载变化的showFooter的值
    return state.refresh_token;
  },
  Token(state) {
    // 方法名随意,主要是用来承载变化的changableNum的值
    return state.token || sessionStorage.getItem("token");
  },
  UserInfo(state) {
    return state.userInfo || JSON.parse(sessionStorage.getItem("userInfo"));
  },
  UUID(state) {
    return state.uuid || sessionStorage.getItem("uuid");
  },
  VehicleType(state) {
    return state.VehicleType;
  },
  StationCode(state) {
    return state.StationCode;
  }
};
const mutations = {
  // 写法与getters相类似
  // 组件想要对于vuex 中的数据进行的处理
  // 组件中采用this.$store.commit('方法名') 的方式调用，实现充分解耦
  // 内部操作必须在此刻完成(同步)
  SAVE_TOKEN(state, token) {
    // 第一个参数为 state 用于变更状态 登录
    sessionStorage.setItem("token", token);
    state.token = token;
    // console.log("savetoken");
  },
  REMOVE_TOKEN(state) {
    // 退出登录
    sessionStorage.removeItem("token");
    state.token = "";
    // console.log("removetoken");
  },
  SAVE_RETOKEN(state, retoken) {
    sessionStorage.setItem("retoken", retoken);
    state.refresh_token = retoken;
    // console.log("saveretoken");
  },
  SAVE_USERINFO(state, userinfo) {
    sessionStorage.setItem("userInfo", JSON.stringify(userinfo));
    state.userInfo = userinfo;
    // console.log("saveuserInfo");
  },
  REMOVE_USERINFO(state) {
    sessionStorage.removeItem("userInfo");
    state.userInfo = null;
    // console.log("removeuserInfo");
  },
  SAVE_UUID(state, uuid) {
    sessionStorage.setItem("uuid", uuid);
    state.uuid = uuid;
    // console.log("saveUUID");
  },
  REMOVE_UUID(state) {
    sessionStorage.removeItem("uuid");
    state.uuid = null;
    // console.log("removeUUID");
  },
  SetVehicleType(state, vehicleType) {
    state.VehicleType = vehicleType;
    // console.log("VehicleType");
  },
  SetStationCode(state, stationCode) {
    state.StationCode = stationCode;
    // console.log("StationCode");
  },
  REMOVE_StationCode(state) {
    sessionStorage.removeItem("StationCode");
    state.StationCode = null;
  }
};

const actions = {
  savetoken(context, token) {
    // 自定义触发mutations里函数的方法，context与store 实例具有相同方法和属性
    context.commit("SAVE_TOKEN", token);
  },
  removetoken(context) {
    // 同上注释
    context.commit("REMOVE_TOKEN");
  },
  saveretoken(context, retoken) {
    context.commit("SAVE_RETOKEN", retoken);
  },
  saveuser(context, userinfo) {
    context.commit("SAVE_USERINFO", userinfo);
  },
  removeuser(context) {
    // 同上注释
    context.commit("REMOVE_USERINFO");
  },
  saveuuid(context, uuid) {
    context.commit("SAVE_UUID", uuid);
  },
  removeuuid(context) {
    context.commit("REMOVE_UUID");
  },
  LoadVehicleType() {
    var url = "/api/DictCode/GetVehicleTypeDict";
    axios
      .get(url)
      .then(res => {
        // 调用接口
        context.commit("SetVehicleType", res.Data); // 通过接口获取的后台数据保存到store中，等待组件取用
      })
      .catch(error => {
        window.console.log(error);
      });
  },
  saveStationCode(context, stationCode) {
    context.commit("SetStationCode", stationCode);
  },
  removeStationCode(context) {
    context.commit("REMOVE_StationCode");
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/js/store/modules/user.js